/**
 * Logger utility for consistent logging across the application
 * Disabled in production to avoid exposing internal logic
 */

const isDevelopment = process.env.NODE_ENV === 'development';

const logger = {
  error: (message, error) => {
    if (isDevelopment) {
      console.error(message, error);
    }
    // In production, you could send to an error tracking service like Sentry
    // Example: Sentry.captureException(error);
  },
  
  warn: (message, data) => {
    if (isDevelopment) {
      console.warn(message, data);
    }
  },
  
  info: (message, data) => {
    if (isDevelopment) {
      console.log(message, data);
    }
  },
  
  debug: (message, data) => {
    if (isDevelopment) {
      console.debug(message, data);
    }
  }
};

export default logger;
